<template>
  <div>
      <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
              <li class="breadcrumb-item" @click="$router.push('/security')" style="cursor: pointer">Seguridad</li>
              <li class="breadcrumb-item active" aria-current="page">Control de Accesos</li>
          </ol>
      </nav>
      <div class="container-fluid">
          <div v-if="data!=null">
              <div class="result-zone" style="margin-top:20px;" v-for="role in data">
                  <div class="card">
                      <div class="card-body">
                          <h5 class="card-title">{{role.name}} | RID: {{role.id}}
                              <button id="verModal" v-on:click="showModal(role)" class="btn btn-success btn-raised" style="border-radius: 100%;float:right">
                                  +
                              </button>
                          </h5>
                          <table class="table table-hover">
                              <thead>
                              <tr>
                                  <th class="header" style="text-align: left!important">UID</th>
                                  <th class="header" style="text-align: left!important">PPID</th>
                                  <th class="header" style="text-align: left!important">Nombre</th>
                                  <th class="header" style="text-align: left!important">Correo</th>
                                  <th class="header" style="text-align: left!important">U. Acceso</th>
                                  <th class="header" style="text-align: left!important">U. Cambio Contraseña</th>
                                  <th class="header" style="text-align: left!important">Acciones</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="user in role.users">
                                  <td style="font-weight: bold !important;">{{user.uid}}</td>
                                  <td>{{user.ppid}}</td>
                                  <td>{{user.nombre}}</td>
                                  <td>{{user.email}}</td>
                                  <td>{{user.acceso}}</td>
                                  <td>{{user.pass}}</td>
                                  <td><em class="material-icons" style="cursor: pointer" v-on:click="borrar(user.uid,role.id)">delete</em></td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          </div>

          <div class="modal fade" ref="agregar" tabindex="-1" role="dialog" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title">Asignar nuevo {{role_name}}</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="hideModal()">
                              <span aria-hidden="true">&times;</span>
                          </button>
                      </div>
                      <div class="modal-body">
                          <div class="row">
                              <div class="col-md-12">
                                  <div class="row">
                                      <div class="col-md-11">
                                          <input type="text" placeholder="Buscar Usuario..." class="form-control" v-model="search" v-on:keyup.enter="buscarUsuario()">
                                      </div>
                                      <div class="col-md-1">
                                          <button class="form-control btn btn-success btn-raised" style="font-size: 1px;padding-bottom: 2%;" v-on:click="buscarUsuario()" :disabled="buscando">
                                              <em class="material-icons" style="margin-top: -5px;">search</em>
                                          </button>
                                      </div>
                                  </div>
                                  <small>Criterios de busqueda: UID, Nombre o Email</small>
                                  <table class="table table-hover">
                                      <tr>
                                          <th>UID</th>
                                          <th>Nombre</th>
                                          <th>Email</th>
                                          <th>Acción</th>
                                      </tr>
                                      <tr v-for="renglon in dataU">
                                          <td>{{renglon.id}}</td>
                                          <td>{{renglon.nombre}}</td>
                                          <td>{{renglon.email}}</td>
                                          <td> <button type="button" class="btn btn-outline-success" style="border-radius: 5px" v-on:click="seleccionar(renglon.id)" data-dismiss="modal" aria-label="Close">Seleccionar</button> </td>
                                      </tr>
                                  </table>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'accesos',
    props: [],
    mounted() {
      axios.get( '/api/accesos').then(response => {
        this.data = response.data.data
      })
    },
    data() {
      return {
        data: null,
        search:'',
        role_name:'',
        role_id: null,
        dataU: null,
          buscando: false,
      }
    },
    methods: {
      seleccionar(user_id){
            Vue.toasted.show('Asignando rol...', { position: 'bottom-center', closeOnSwipe: false });
            axios.post( '/api/accesos/users/select', {
              user_id: user_id,
              role_id: this.role_id
            })
            .then(response => {
                this.dataU = [];
                Vue.toasted.clear()
                Vue.toasted.show('¡¡ Rol Asignado !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 })
                axios.get( '/api/accesos').then(response => {
                  this.data = response.data.data
                })
            }).catch(error => {
            Vue.toasted.clear()
            Vue.toasted.show('¡ERROR! Algo salió mal...', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000})
          });
      },
      borrar(user_id,role_id){
            Vue.toasted.show('Removiendo rol...', { position: 'bottom-center', closeOnSwipe: false });
            axios.post( '/api/accesos/users/delete', {
              user_id: user_id,
              role_id: role_id
            })
            .then(response => {
                Vue.toasted.clear()
                Vue.toasted.show('¡¡ Rol Removido correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 })
                axios.get( '/api/accesos').then(response => {
                  this.data = response.data.data
                })
            }).catch(error => {
            Vue.toasted.clear()
            Vue.toasted.show('¡ERROR! Algo salió mal...', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000})
          });
      },
        showModal(role){
            this.role_name=role.name;
            this.role_id=role.id;
            let element = this.$refs.agregar;
            $(element).modal('show');
        },
        hideModal(){
            this.role_name='';
            this.role_id=null;
            this.dataU=[];
            let element = this.$refs.agregar;
            $(element).modal('hide');
        },
        buscarUsuario(){
          if(this.buscando==false){
              this.buscando=true;
              if(this.search.length >= 1){
                  axios.post( '/api/accesos/users/search', {
                      search: this.search,
                      role_id: this.role_id
                  }).then(response => {
                      this.dataU = response.data.users;
                      this.buscando = false;
                  });
              }
          }
        }
    },
}
</script>

